/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of a Spark job
*/
export enum SparkJobStatus {
  SPARK_JOB_STATUS_SUBMITTED = 'SUBMITTED',
  SPARK_JOB_STATUS_PENDING = 'PENDING',
  SPARK_JOB_STATUS_SCHEDULED = 'SCHEDULED',
  SPARK_JOB_STATUS_RUNNING = 'RUNNING',
  SPARK_JOB_STATUS_SUCCESS = 'SUCCESS',
  SPARK_JOB_STATUS_FAILED = 'FAILED',
  SPARK_JOB_STATUS_CANCELLING = 'CANCELLING',
  SPARK_JOB_STATUS_CANCELLED = 'CANCELLED',
  SPARK_JOB_STATUS_QUEUED = 'QUEUED'
}
